// Funzione modulare per applicare padding-left basato su un elemento sorgente
function applyDynamicPaddingLeft(sourceSelector, targetsSelectors) {
  function updatePadding() {
    const source = document.querySelector(sourceSelector);
    if (!source) return;

    targetsSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(target => {
        if (!target) return;
        if (target.closest('.header__icon')) return;

        // distanza dal bordo sinistro della viewport
        const left = source.getBoundingClientRect().left;

        // inietta il padding-left
        target.style.paddingLeft = Math.round(left) + 'px';
      });
    });
  }

  // AL LOAD
  window.addEventListener('load', updatePadding);

  // AL RESIZE (ottimizzato con requestAnimationFrame)
  let ticking = false;

  const resizeObserver = new ResizeObserver(entries => {
    if (!ticking) {
      ticking = true;

      setTimeout(() => {
        // requestAnimationFrame garantisce di leggere i valori post-layout
        requestAnimationFrame(() => {
          updatePadding();
          ticking = false;
        });
      }, 300);
    }
  });

  // Avvia l'osservazione sul corpo della pagina (o un contenitore specifico)
  resizeObserver.observe(document.body);

  // restituisce la funzione in caso tu voglia richiamarla manualmente
  return updatePadding;
}

applyDynamicPaddingLeft('.header__inline-menu > .list-menu', [
  '.mega-menu__list'//,
  //'.header__submenu'
]);

// Funzione modulare per toggle open tag of details - basato su un elemento sorgente
function closeOnClickOutside(selector) {
  const elements = document.querySelectorAll(selector);

  elements.forEach(details => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;

      const closeAction = (e) => {
        if (!details.contains(e.target)) {
          details.removeAttribute('open');
          document.removeEventListener('click', closeAction);
        }
      };

      // Il timeout serve a non intercettare il click di apertura stesso
      setTimeout(() => document.addEventListener('click', closeAction), 0);
    });
  });
}

// La usi così per tutti i details
closeOnClickOutside('details.header__icon--account');

// Funzione per iniettare stili nel Shadow DOM di Shopify Forms
function observeShopifyForms() {
  const targetTag = 'shopify-forms-embed';

  const injectStyle = (el) => {
    // Verifichiamo se la Shadow Root è accessibile
    if (el.shadowRoot) {
      // Evitiamo doppie iniezioni
      if (el.shadowRoot.querySelector('#sidea-custom-styles')) return;

      const style = document.createElement('style');
      style.id = 'sidea-custom-styles';
      style.textContent = `
        [data-testid="btn-form-submit"] {
          font-family: var(--font-heading-family) !important;
          font-weight: var(--font-heading-weight) !important;
          font-size: 1.6rem !important;
          text-transform: uppercase !important;
        }
        [data-sizing="form-wrapper"] section {
          margin-bottom: 1rem !important;
        }
        [data-sizing="form-wrapper"] h2 {
          margin-bottom: 1rem !important;
        }
        [data-sizing="form-wrapper"] p {
          font-size: 1.6rem !important;
          line-height: 1.4 !important;
        }
        [data-sizing="form-wrapper"] form + div p {
          font-size: 1.2rem !important;
          line-height: 1.2 !important;
        }
        /* Puoi aggiungere qui altri stili per gli input, ecc. */
      `;
      el.shadowRoot.appendChild(style);
      console.log('Stili iniettati correttamente nel Shadow DOM di Shopify Forms');
    }
  };

  // 1. Controllo immediato se l'elemento esiste già
  const existing = document.querySelector(targetTag);
  if (existing) injectStyle(existing);

  // 2. Osserviamo il DOM per intercettare quando l'app inietta il tag
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeName && node.nodeName.toLowerCase() === targetTag) {
          injectStyle(node);
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

// Avviamo l'osservatore
observeShopifyForms();